import { API } from "aws-amplify";

const api_name = process.env.REACT_APP_STAGE === "DEV" ? process.env.REACT_APP_API_NAME_DEV : process.env.REACT_APP_API_NAME_PROD;

const getDropdownData = async () => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "getAllDropDownData",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    if (response.status === 200 && response.data) {
      const result = JSON.parse(response.data.body);
      let resultData = [];

      result.users.forEach((item, index) => {
        let data = {
          id: index + 1,
          row_id: item.id.S,
          name: item.data_name.S,
          type: item.data_type.S,
          json_data: item.json_data ? JSON.parse(item.json_data.S) : "{}",
          image: item.image ? item.image.S : "",
          client_code: item.client_code ? item.client_code.S : "",
          created_at: item.created_at.S,
          updated_at: item.updated_at.S,
          created_by: item.created_by.S,
        };
        resultData.push(data);
      });

      return resultData;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching registration codes.");
    return [];
  }
};

const addDropDownData = async (formData, edit) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: edit ? "updateDropDownData" : "addDropDownData",
        id: edit ? formData.id : new Date().getTime().toString(),
        data_name: formData.name,
        data_type: formData.data_type,
        image: formData.image ? formData.image : "",
        client_code: formData.client_code ? formData.client_code : "",
        json_data: formData.json_data ? JSON.stringify(formData.json_data) : "{}",
        created_at: new Date().toLocaleDateString(),
        updated_at: new Date().toLocaleDateString(),
        created_by: formData.email,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);

    return response;
  } catch (error) {
    console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const deleteDropDownData = async (id, data_type) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "deleteDropDownData",
        id: id,
        data_type: data_type,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error deleting dropdown data" }) } };
  }
};

const addUser = async (userData, editUser) => {
  console.log(userData, editUser);
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: editUser ? "updateUser" : "addUser",
        fname: userData?.firstName || "",
        lname: userData?.lastName || "",
        email: userData?.email.toLowerCase() || "",
        phone: userData?.phoneNumber || "",
        password: userData?.password || "",
        dob: userData?.dateOfBirth || "",
        qualification: userData?.qualification || "",
        role: userData?.role || "User",
        batch: Array.isArray(userData?.programCode) 
          ? userData.programCode.join(",") 
          : userData?.programCode || "",
        graduationYear: userData?.graduationYear
          ? userData.graduationYear.toString()
          : "",
        course: userData?.selectedCourses
          ? userData.selectedCourses.toString()
          : "",
        status: userData?.status || "Active",
        designation: userData?.designation || "",
        experience_level: userData?.experience_level || "",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    console.log(params, userData);
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    //console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};
const AdminCreateUserCognito = async (userData, editUser) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "AdminCreateUser",
        fname: userData?.firstName || "",
        lname: userData?.lastName || "",
        email: userData?.email.toLowerCase() || "",
        phone: userData?.phoneNumber || "",
        password: userData?.password || "",
        dob: userData?.dateOfBirth || "",
        qualification: userData?.qualification || "",
        role: userData?.role || "User",
        batch: Array.isArray(userData?.programCode) 
          ? userData.programCode.join(",") 
          : userData?.programCode || "",
        graduationYear: userData?.graduationYear
          ? userData.graduationYear.toString()
          : "",
        course: userData?.selectedCourses
          ? userData.selectedCourses.toString()
          : "",
        status: userData?.status || "Active",
        designation: userData?.designation || "",
        experience_level: userData?.experience_level || "",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    console.log(params, userData);
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    //console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};
const addRatingData = async (formData, edit) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: edit ? "updateRating" : "addRating",
        id: formData.id, //update
        form_name: formData.name, //update
        start_date: formData.start_date, //update
        end_date: formData.end_date, //update
        program_code: formData.program_code, //update
        json: formData.json, //update
        questions: formData.questions, //update
        created_at: formData.created_at,
        updated_at: formData.updated_at,
        created_by: formData.created_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    //console.log(params);
    const response = await API.post(apiName, path, params);
    //console.log(response);
    // if (response.data && response.data.statusCode === 200) {
    //     const result = JSON.parse(response.data.body);
    //     return result;
    // }
    return response;
  } catch (error) {
    //console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const getRatingData = async () => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "getRatingData",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      //console.log(result);
      result.rating.forEach((item, index) => {
        let data = {
          id: index + 1,
          form_id: item.id.S,
          name: item.form_name.S,
          start_date: item.start_date.S,
          end_date: item.end_date.S,
          program_code: item.program_code.S,
          json: item.json.S,
          questions: item.questions.S,
          created_at: item.created_at.S,
          created_by: item.email.S,
          updated_at: item.updated_at.S,
        };
        resultData.push(data);
      });

      return resultData;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};

const DeleteRatingData = async (id, email) => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "deleteRating",
        id: id,
        email: email,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      return result;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};

const getUsers = async () => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API

    let params = {
      body: {
        command: "getUsers",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    if (response.data.statusCode === 200) {
      let result = JSON.parse(response.data.body);

      let resultData = result.users.map((item, index) => {
        return {
          id: index + 1,
          name: `${item.fname.S} ${item.lname.S}`,
          fname: item.fname.S,
          lname: item.lname.S,
          email: item.email.S,
          dob: item.dob.S,
          phone: item.phone.S,
          qualification: item.qualification.S,
          role: item.user_role.S,
          programCode: item.user_batch.S,
          course: item.course.S,
          graduationYear: item.graduation_year.S,
          status: item.user_status.S,
          git_url: item.git_url ? item.git_url.S : "",
          linkedin_url: item.linkedin_url ? item.linkedin_url.S : "",
          designation: item.designation ? item.designation.S : "",
          experience_level: item.experience_level ? item.experience_level.S : "",
        };
      });
      return resultData;
    } else {
      console.log(`Failed to fetch data. Status Code: ${response.data.statusCode}`);
      return []; // Return empty array on API error
    }
  } catch (error) {
    console.log('Unable to load the data. Please try again.', error);
    return []; // Return empty array on exception
  }
};

const getUser = async (data) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API

    let params = {
      body: {
        command: "getUser",
        email: data.email
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    if (response.data.statusCode === 200) {
      let result = JSON.parse(response.data.body);

      let resultData = result.users.map((item, index) => {
        return {
          id: index + 1,
          name: `${item.fname.S} ${item.lname.S}`,
          fname: item.fname.S,
          lname: item.lname.S,
          email: item.email.S,
          // password: item.password.S,
          dob: item.dob.S,
          phone: item.phone.S,
          qualification: item.qualification.S,
          role: item.user_role.S,
          programCode: item.user_batch.S,
          course: item.course.S,
          graduationYear: item.graduation_year.S,
          status: item.user_status.S,
          git_url: item.git_url ? item.git_url.S : "",
          linkedin_url: item.linkedin_url ? item.linkedin_url.S : "",
          designation: item.designation ? item.designation.S : "",
          experience_level: item.experience_level ? item.experience_level.S : "",
        };
      });
      return resultData;
    } else {
      //console.log(`Failed to fetch data. Status Code: ${response.data.statusCode}`);
    }
  } catch (error) {
    //console.log('Unable to load the data. Please try again.', error);
  }
};
const addProfileImage = async (fileName, imageData, type) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "uploadProfileImage",
        fileName: fileName,
        imageData: imageData,
        type: type ? type : "profile_images",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    // console.log(params)
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    //console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const addProfileData = async (email, git, linkedin, input) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "updateProfileData",
        email: email,
        git_url: git,
        linkedin_url: linkedin,
        input: input,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    // console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};
const updateUserImage = async (email, imageUrl) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "updateUserWithImage",
        email: email,
        profile_image: imageUrl,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    throw error; // Rethrow the error to let the caller handle it
  }
};

const uploadFile = async (fileName, fileData, folderName) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "uploadFile",
        fileName: fileName,
        fileData: fileData,
        folderName: folderName,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    // console.log(params)
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    //console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const addAssignment = async (formData, edit, update) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: edit
          ? update
            ? "updateAssessment"
            : "updateAssignment"
          : "addAssignment",
        id: formData.id, //update
        assignment_name: formData.assignment_name,
        assignment_type: formData.assignment_type,
        program_code: formData.program_code, //update
        assigned_to: formData.assigned_to,
        assignment_topic: formData.assignment_topic,
        start_date: formData.start_date, //update
        end_date: formData.end_date, //update
        questions: formData.questions, //update
        fileName: formData.fileName,
        json: formData.json, //update
        interpretations: formData.interpretations,
        recommendations: formData.recommendations,
        instructions: formData.instructions ? formData.instructions : "",
        created_at: formData.created_at,
        updated_at: formData.updated_at,
        created_by: formData.created_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);

    return response;
  } catch (error) {
    console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const getAssignments = async () => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "getAssignments",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    // console.log(response);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      // console.log(result);
      result.assignments.forEach((item, index) => {
        let data = {
          id: index + 1,
          form_id: item.id.S,
          assignment_name: item.assignment_name.S,
          assignment_type: item.assignment_type.S,
          program_code: item.program_code.S,
          assigned_to: item.assigned_to.S
            ? JSON.parse(item.assigned_to.S)
            : item.assigned_to.S,
          assignment_topic:
            !item.assignment_topic.S === "assessment"
              ? JSON.parse(item.assignment_topic.S)
              : item.assignment_topic.S,
          start_date: item.start_date.S,
          end_date: item.end_date.S,
          questions: item.questions.S
            ? JSON.parse(item.questions.S)
            : item.questions.S,
          interpretations: item.interpretations.S
            ? JSON.parse(item.interpretations.S)
            : item.interpretations.S,
          recommendations: item.recommendations.S
            ? JSON.parse(item.recommendations.S)
            : item.recommendations.S,
          fileName: item.file_name.S,
          json:
            item.json.S && !item.assignment_topic.S === "assessment"
              ? JSON.parse(item.json.S)
              : item.json.S,
          instructions:
            item.instructions && !item.assignment_topic.S === "assessment"
              ? JSON.parse(item.instructions.S)
              : item.instructions
                ? item.instructions.S
                : "",
          created_at: item.created_at.S,
          updated_at: item.updated_at.S,
          created_by: item.email.S,
        };
        resultData.push(data);
      });
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching registration codes.");
    return [];
  }
};

const deleteAssignment = async (id) => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "deleteAssignment",
        id: id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      return result;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};

const addResource = async (formData, edit) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "addResource",
        id: formData.id,
        created_by: formData.created_by,
        notes: formData.notes,
        resource_type: formData.resource_type,
        resource_url: formData.resource_url,
        fileName: formData.fileName,
        created_at: formData.created_at,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);

    return response;
  } catch (error) {
    console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};

const getResources = async () => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "getResources",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      result.assignments.forEach((item, index) => {
        let data = {
          id: index + 1,
          resource_id: item.id.S,
          created_by: item.created_by.S,
          notes: item.notes.S,
          fileName: item.file_name.S,
          created_at: item.created_at.S,
          resource_type: item.resource_type.S,
          resource_url: item.resource_url.S,
        };
        resultData.push(data);
      });
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching Resources.");
    return [];
  }
};

const deleteResource = async (id) => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "deleteResource",
        id: id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      return result;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};
const setPassword = async (email, password) => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "AdminSetUserPassword",
        email: email,
        password: password,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    console.log(params);
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      return result;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};


const addUserAssessmentResults = async (assessmentData) => {
  try {
    let apiName = api_name;
    let path = ""; // replace this with the path you have configured on your API
    let params = {
      body: {
        command: "addUserAssessmentResults",
        id: assessmentData.id,
        assessment_id: assessmentData.assessment_id,
        json: assessmentData.json,
        user_id: assessmentData.user_id,
        created_at: assessmentData.created_at
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    console.log(params);
    const response = await API.post(apiName, path, params);
    
    return response;
  } catch (error) {
    console.log(error);
    throw error; // Rethrow the error to let the caller handle it
  }
};
const getUserAssessmentResults = async (assessmentId, userId) => {
  try {
    const apiName = api_name;
    const path = ""; // Replace with your actual path

    const params = {
      body: {
        command: "getUserAssessmentResults",
        assessment_id: assessmentId,
        user_id: userId,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);

    if (response?.data?.statusCode === 200 && response?.data?.body) {
      const parsedBody = JSON.parse(response.data.body);
      if (parsedBody?.user_assessment_results) {
        const result = parsedBody.user_assessment_results;
        
        // Transform the result to a consistent format
        return result.map(item => ({
          id: item.id?.S || item.id,
          user_id: item.user_id?.S || item.user_id,
          json: item.json?.S ? JSON.parse(item.json.S) : (item.json || {}),
          assessment_id: item.assessment_id?.S || item.assessment_id,
          created_at: item.created_at?.S || item.created_at,
        }));
      }
    }

    return [];
  } catch (error) {
    console.error("An error occurred while fetching user assessment results.", error);
    return [];
  }
};

const getAssessmentResults = async (assessmentId) => {
  try {
    const apiName = api_name;
    const path = ""; // Replace with your actual path

    const params = {
      body: {
        command: "getAssessmentResults",
        assessment_id: assessmentId,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };

    const response = await API.post(apiName, path, params);

    if (response?.data?.statusCode === 200 && response?.data?.body) {
      const parsedBody = JSON.parse(response.data.body);
      if (parsedBody?.user_assessment_results) {
        const result = parsedBody.user_assessment_results;
        
        // Transform the result to a consistent format
        return result.map(item => ({
          id: item.id?.S || item.id,
          user_id: item.user_id?.S || item.user_id,
          json: item.json?.S ? JSON.parse(item.json.S) : (item.json || {}),
          assessment_id: item.assessment_id?.S || item.assessment_id,
          created_at: item.created_at?.S || item.created_at,
        }));
      }
    }

    return [];
  } catch (error) {
    console.error("An error occurred while fetching assessment results.", error);
    return [];
  }
};

const deleteUserAssessment = async (id) => {
  try {
    let apiName = api_name;
    let path = ""; //replace this with the path you have configured on your API
    let params = {
      body: {
        command: "deleteUserAssessment",
        id: id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      return result;
    } else {
      //console.log('Unable to load the data. Please try again.');
      return [];
    }
  } catch (error) {
    //console.log(error, 'An error occurred while fetching registration codes.');
    return [];
  }
};

// User Rating Functions
const addUserRating = async (formData) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "addUserRating",
        id: formData.id,
        parent_id: formData.parent_id,
        user_id: formData.user_id,
        json: formData.json,
        questions: formData.questions,
        created_at: formData.created_at,
        updated_at: formData.updated_at,
        created_by: formData.created_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while adding user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error adding user rating" }) } };
  }
};

const updateUserRating = async (formData) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "updateUserRating",
        id: formData.id,
        parent_id: formData.parent_id,
        user_id: formData.user_id,
        json: formData.json,
        questions: formData.questions,
        mentor_comment: formData.mentor_comment || "",
        updated_at: formData.updated_at,
        created_by: formData.created_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while updating user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error updating user rating" }) } };
  }
};

const deleteUserRating = async (id, user_id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "deleteUserRating",
        id: id,
        user_id: user_id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while deleting user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error deleting user rating" }) } };
  }
};

const getAllUserRatingResults = async () => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getAllUserRatingResults",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      console.log(result, "Parsed User Rating Results");
      // Ensure we always return an array
      return Array.isArray(result) ? result : (result.results || result.ratingResults || []);
    } else {
      console.log(`Failed to fetch user rating results. Status Code: ${response.data?.statusCode || 'unknown'}`);
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching all user rating results.");
    return [];
  }
};

const getUserRatingResults = async (user_id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getUserRatingResults",
        user_id: user_id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      console.log(response, "User Rating Results");
      const result = JSON.parse(response.data.body);
      // Return the array of rating results
      return result;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching user rating results.");
    return [];
  }
};

// Growth Session Functions
const createGrowthSession = async (inputs) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "createGrowthSession",
        ...inputs,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while creating growth session.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error creating growth session" }) } };
  }
};

const updateGrowthSession = async (inputs) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "updateGrowthSession",
        ...inputs,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while updating growth session.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error updating growth session" }) } };
  }
};

const getGrowthSession = async (inputs) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getGrowthSession",
        ...inputs,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while fetching growth session.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error fetching growth session" }) } };
  }
};

const getAllGrowthSessions = async (inputs = {}) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getAllGrowthSessions",
        ...inputs,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while fetching growth sessions.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error fetching growth sessions" }) } };
  }
};

const deleteGrowthSession = async (inputs) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "deleteGrowthSession",
        ...inputs,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while deleting growth session.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error deleting growth session" }) } };
  }
};



// Client Management Functions
const addClient = async (formData) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "addClient",
        id: new Date().getTime().toString(),
        client_code: formData.client_code,
        client_logo: formData.client_logo || "",
        description: formData.description || "",
        status: formData.status || "Active",
        page_privileges: JSON.stringify(formData.page_privileges || []),
        created_by: formData.created_by,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while adding client.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error adding client" }) } };
  }
};

const getClient = async (id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getClient",
        id: id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while fetching client.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error fetching client" }) } };
  }
};

const updateClient = async (formData) => {
  try {
    let apiName = api_name;
    let path = "";
    
    // Ensure client_logo is always a string, not an object
    const clientLogo = typeof formData.client_logo === 'object' 
      ? (formData.client_logo?.S || "") 
      : (formData.client_logo || "");
    
    let params = {
      body: {
        command: "updateClient",
        id: formData.client_id,
        client_code: formData.client_code,
        client_logo: clientLogo,
        description: formData.description || "",
        status: formData.status || "Active",
        page_privileges: JSON.stringify(formData.page_privileges || []),
        created_by: formData.created_by,
        updated_at: new Date().toISOString(),
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while updating client.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error updating client" }) } };
  }
};

const deleteClient = async (client_id, client_code) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "deleteClient",
        client_id: client_id,
        client_code: client_code,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while deleting client.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error deleting client" }) } };
  }
};

const getAllClients = async () => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getAllClients",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      if (result.clients) {

        result.clients.forEach((item, index) => {
          let data = {
            id: index + 1,
            client_id: item.id?.S || item.id,
            client_code: item.client_code?.S || item.client_code,
            client_logo: item.client_logo?.S || item.client_logo || "",
            description: item.description?.S || item.description || "",
            status: item.status?.S || item.status || "Active",
            page_privileges: item.page_privileges?.S ? JSON.parse(item.page_privileges.S) : (item.page_privileges || []),
            created_by: item.created_by?.S || item.created_by,
            created_at: item.created_at?.S || item.created_at,
            updated_at: item.updated_at?.S || item.updated_at,
          };
          resultData.push(data);
        });
      }
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching clients.");
    return [];
  }
};

// Program User Ratings Functions
const addProgramUserRating = async (ratingData) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "addProgramUserRating",
        id: ratingData.id || new Date().getTime().toString(),
        user_id: ratingData.user_id,
        rating_json: ratingData.rating_json,
        program_code: ratingData.program_code,
        created_by: ratingData.created_by,
        created_at: ratingData.created_at || new Date().toISOString(),
        updated_at: ratingData.updated_at || new Date().toISOString(),
        updated_by: ratingData.updated_by || ratingData.created_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while adding program user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error adding program user rating" }) } };
  }
};

const updateProgramUserRating = async (ratingData) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "updateProgramUserRating",
        id: ratingData.id,
        user_id: ratingData.user_id,
        rating_json: ratingData.rating_json,
        program_code: ratingData.program_code,
        updated_at: new Date().toISOString(),
        updated_by: ratingData.updated_by,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while updating program user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error updating program user rating" }) } };
  }
};

const getProgramUserRating = async (id, user_id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getProgramUserRating",
        id: id,
        user_id: user_id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      if (result.rating) {
        const item = result.rating;
        return {
          id: item.id?.S || item.id,
          user_id: item.user_id?.S || item.user_id,
          rating_json: item.rating_json?.S ? JSON.parse(item.rating_json.S) : (item.rating_json || {}),
          program_code: item.program_code?.S || item.program_code,
          created_at: item.created_at?.S || item.created_at,
          created_by: item.created_by?.S || item.created_by,
          updated_at: item.updated_at?.S || item.updated_at,
          updated_by: item.updated_by?.S || item.updated_by,
        };
      }
    }
    return null;
  } catch (error) {
    console.log(error, "An error occurred while fetching program user rating.");
    return null;
  }
};

const getAllProgramUserRatings = async () => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getAllProgramUserRatings",
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      if (result.ratings) {
        result.ratings.forEach((item, index) => {
          let data = {
            row_index: index + 1,
            id: item.id?.S || item.id,
            user_id: item.user_id?.S || item.user_id,
            rating_json: item.rating_json?.S ? JSON.parse(item.rating_json.S) : (item.rating_json || {}),
            program_code: item.program_code?.S || item.program_code,
            created_at: item.created_at?.S || item.created_at,
            created_by: item.created_by?.S || item.created_by,
            updated_at: item.updated_at?.S || item.updated_at,
            updated_by: item.updated_by?.S || item.updated_by,
          };
          resultData.push(data);
        });
      }
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching all program user ratings.");
    return [];
  }
};

const getProgramUserRatingsByProgramCode = async (program_code) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getProgramUserRatingsByProgramCode",
        program_code: program_code,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      if (result.ratings) {
        result.ratings.forEach((item, index) => {
          let data = {
            row_index: index + 1,
            id: item.id?.S || item.id,
            user_id: item.user_id?.S || item.user_id,
            rating_json: item.rating_json?.S ? JSON.parse(item.rating_json.S) : (item.rating_json || {}),
            program_code: item.program_code?.S || item.program_code,
            created_at: item.created_at?.S || item.created_at,
            created_by: item.created_by?.S || item.created_by,
            updated_at: item.updated_at?.S || item.updated_at,
            updated_by: item.updated_by?.S || item.updated_by,
          };
          resultData.push(data);
        });
      }
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching program user ratings by program code.");
    return [];
  }
};

const getProgramUserRatingsByUserId = async (user_id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "getProgramUserRatingsByUserId",
        user_id: user_id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    if (response.data && response.data.statusCode === 200) {
      const result = JSON.parse(response.data.body);
      let resultData = [];
      if (result.ratings) {
        result.ratings.forEach((item, index) => {
          let data = {
            row_index: index + 1,
            id: item.id?.S || item.id,
            user_id: item.user_id?.S || item.user_id,
            rating_json: item.rating_json?.S ? JSON.parse(item.rating_json.S) : (item.rating_json || {}),
            program_code: item.program_code?.S || item.program_code,
            created_at: item.created_at?.S || item.created_at,
            created_by: item.created_by?.S || item.created_by,
            updated_at: item.updated_at?.S || item.updated_at,
            updated_by: item.updated_by?.S || item.updated_by,
          };
          resultData.push(data);
        });
      }
      return resultData;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error, "An error occurred while fetching program user ratings by user ID.");
    return [];
  }
};

const deleteProgramUserRating = async (id, user_id) => {
  try {
    let apiName = api_name;
    let path = "";
    let params = {
      body: {
        command: "deleteProgramUserRating",
        id: id,
        user_id: user_id,
      },
      response: true,
      convertEmptyValues: true,
      headers: {},
    };
    const response = await API.post(apiName, path, params);
    return response;
  } catch (error) {
    console.log(error, "An error occurred while deleting program user rating.");
    return { data: { statusCode: 500, body: JSON.stringify({ message: "Error deleting program user rating" }) } };
  }
};

export {
  //data management
  getDropdownData,
  addDropDownData,
  deleteDropDownData,
  //rating
  addRatingData,
  getRatingData,
  DeleteRatingData,
  addUserRating,
  updateUserRating,
  deleteUserRating,
  getAllUserRatingResults,
  getUserRatingResults,
  //user
  addUser,
  getUsers,
  getUser,
  //profile
  addProfileImage,
  updateUserImage,
  addProfileData,
  uploadFile,
  //assessments
  addAssignment,
  getAssignments,
  deleteAssignment,
  addUserAssessmentResults,
  getUserAssessmentResults,
  getAssessmentResults,
  deleteUserAssessment,
  //resources
  addResource,
  getResources,
  deleteResource,
  //cognito
  setPassword,
  AdminCreateUserCognito,
  // Growth Session Functions
  createGrowthSession,
  updateGrowthSession,
  getGrowthSession,
  getAllGrowthSessions,
  deleteGrowthSession,
  // clients
  addClient,
  getAllClients,
  getClient,
  updateClient,
  deleteClient,
  // Program User Ratings
  addProgramUserRating,
  updateProgramUserRating,
  getProgramUserRating,
  getAllProgramUserRatings,
  getProgramUserRatingsByProgramCode,
  getProgramUserRatingsByUserId,
  deleteProgramUserRating
};